import { createSelector } from "reselect";

const selectToursState = (state) => state.tours;

export const selectPersonalAreaTour = createSelector(
  [selectToursState],
  (tours) => tours.personalAreaTour
)